import { useQuery } from '@tanstack/react-query';
import { useRedirect, useUser } from '../contexts';
import { useInsureIQApiClient } from '../contexts/InsureIQApiContextProvider';

const removeSearchParams = (...paramNames: string[]) => {
  const urlObject = new URL(window.location.href);
  paramNames.forEach((paramName) => urlObject.searchParams.delete(paramName));
  window.history.replaceState({}, document.title, urlObject.toString());
};

const getSearchParams = (...paramNames: string[]) => {
  const searchParams = new URLSearchParams(window.location.search);
  return paramNames.reduce(
    (acc, paramName) => {
      acc[paramName] = searchParams.get(paramName);
      return acc;
    },
    {} as Record<string, string | null>
  );
};

export const useVerifyToken = () => {
  const { insureIQApiClient } = useInsureIQApiClient();
  const { user, setUser } = useUser();
  const { redirectOrNavigate } = useRedirect();
  const { iiqCode: code, redirect: redirectFromQueryParams } = getSearchParams(
    'iiqCode',
    'redirect'
  );

  useQuery(
    ['verifyToken'],
    async () => {
      removeSearchParams('iiqCode');
      const response = await insureIQApiClient.confirmAccount(code!);

      if (response) {
        setUser(response.user);

        if (redirectFromQueryParams) {
          redirectOrNavigate(redirectFromQueryParams, {
            replace: true,
          });
        }
      }

      return response;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!code,
      retry: false,
      staleTime: Infinity,
      refetchOnReconnect: false,
    }
  );

  return {
    code,
    user,
  };
};
